const screenBlogData = {
  name: 'Understanding Screen',
  description: 'What is Screen GNU, why you may need a tool like Screen and many of the common commands used with the popular terminal multiplexer.',
  link: 'https://medium.com/@piercefrank10/understanding-screen-108173a55474',
  type: 'Blog'
}

const vanillaSWBlogData = {
  name: 'Vanilla Service Workers in React',
  description: 'Achieving PWA compliance and offline compatibility in React through Service Workers without external libraries, and why cache busting hashes make it a rare feat.',
  link: 'https://piercefrank10.medium.com/vanilla-service-workers-in-react-89fc604339d0',
  type: 'Blog'
}

const renderingBlogData = {
  name: 'Short-Circuit Evaluation in React',
  description: 'Conditional rendering in React is great, here’s a trick to make sure you don’t get caught out by Javascript’s short-circuit evaluation.',
  link: 'https://piercefrank10.medium.com/short-circuit-evaluation-conditional-rendering-a2dbc2220176',
  type: 'Tips & Tricks'
}

const resetCSSData = {
  name: 'My Reset CSS',
  description: 'A Reset CSS that works for me. It’s similar to many of the classic resets with my own twist, feel free to use it as and when you wish.',
  link: 'https://piercefrank10.medium.com/my-reset-css-7c9f693fbcc4',
  type: 'Blog'
}

export { screenBlogData, vanillaSWBlogData, renderingBlogData, resetCSSData }
